import { Component, inject, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClassificationTypeService, DocRole } from '@digiwall/goliath-core/proxy';
import { BaseStockDocDetailHelperService } from '../../../base-docs/detail/base-stock-doc-detail';
import {
  CreateStockDocMovementDto,
  DayBookService,
  StockDocDefaultValueDto,
  StockDocMovementDto,
  StockDocMovementService,
} from '@digiwall/goliath-documents/proxy';
import {
  StockDocDetailComponent,
  StockDocDetailComponentImports,
  StockDocDetailComponentProviders,
} from '../../stock-doc-detail.component';
import StockDocMovementLinesEditorComponent from './stock-doc-movement-lines/stock-doc-movement-lines-editor.component';
import { SubscriptionService, LocalizationService, ConfigStateService } from '@abp/ng.core';
import { ToasterService, ConfirmationService } from '@abp/ng.theme.shared';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeactivatableComponentService } from '@digiwall/core';
import { BreadcrumbService } from 'xng-breadcrumb';
import { DocTemplateService } from '../../../base-docs/detail/doc-template-selection/doc-template.service';

@Component({
  selector: 'document-stock-doc-movement-detail',
  templateUrl: './stock-doc-movement-detail.component.html',
  providers: [BaseStockDocDetailHelperService, ...StockDocDetailComponentProviders],
  imports: [StockDocMovementLinesEditorComponent, ...StockDocDetailComponentImports],
})
export class StockDocMovementDetailComponent
  extends StockDocDetailComponent<
    StockDocMovementService,
    StockDocMovementDto,
    CreateStockDocMovementDto,
    StockDocDefaultValueDto
  >
  implements OnInit, OnDestroy
{
  @ViewChild('stockDocLineGrid')
  stockDocLineGrid!: StockDocMovementLinesEditorComponent;

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    docService: StockDocMovementService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    classificationTypeService: ClassificationTypeService,
    docTemplateService: DocTemplateService,
    injector: Injector,
    config: ConfigStateService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      docService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      config,
      confirmationService,
      deactivableComponentService,
    );
  }

  override get docRole() {
    return DocRole.StockDocMovement;
  }

  get isSerialEntry() {
    return this.router.url.split('/').includes('stock-entry');
  }

  override save() {
    if (!this.stockDocLineGrid) {
      super.save();
      return;
    }

    this.stockDocLineGrid.beforeSaveDocument().subscribeOnce(() => {
      super.save();
    });
  }
  override get formModel() {
    const formModel = super.formModel;
    return this.isSerialEntry
      ? Object.assign({}, formModel, {
          copyLineData: [false],
          printLabel: [false],
        })
      : formModel;
  }

  override setDefaultValue(response: StockDocDefaultValueDto) {
    super.setDefaultValue(response);
    if (this.isSerialEntry) {
      this.form.get('copyLineData').setValue(true);
      this.form.get('printLabel').setValue(true);
    }
  }
}
